import { spawn } from 'redux-saga/effects';

import { watchGetDrafts } from './getDrafts';

export default function* saga() {
  yield spawn(watchGetDrafts);
}
